/**
 * Study Design randomization as the page shows it. A stored platform default
 * (stratification "Site", or "Site" and "Age Group"; a "method" that is the
 * protocol's yes/no word such as "randomized"; subject ID "{SITE}-{SEQUENCE:4}")
 * was never anyone's statement, so it shows as not stated. The documents read
 * it the same way (functions/src/studyProfile/randomizationDetails.ts).
 */
import { storedFactorsStated, storedMethodStated } from '../../../../functions/src/studyProfile/randomizationDetails';

export interface StoredRandomization {
  enabled: boolean;
  method: string;
  stratificationFactors: string[];
}

/** The subject ID format protocol analysis stored on every study until 2026-10-26. */
export const PLATFORM_DEFAULT_SUBJECT_ID_FORMAT = '{SITE}-{SEQUENCE:4}';

/**
 * A new study: the switch on (the page's long-standing default; the documents
 * never treat the switch alone as evidence), nothing else stated.
 */
export const NEW_STUDY_RANDOMIZATION: StoredRandomization = { enabled: true, method: '', stratificationFactors: [] };

export function forDisplay<T extends { randomization?: Partial<StoredRandomization>; subjectIdFormat?: string }>(
  stored: T,
): T & { randomization: StoredRandomization; subjectIdFormat: string } {
  const r = stored.randomization ?? {};
  const subjectIdFormat = stored.subjectIdFormat ?? '';
  return {
    ...stored,
    randomization: {
      enabled: r.enabled === true,
      method: storedMethodStated(r) ?? '',
      stratificationFactors: storedFactorsStated(r),
    },
    subjectIdFormat: subjectIdFormat === PLATFORM_DEFAULT_SUBJECT_ID_FORMAT ? '' : subjectIdFormat,
  };
}
